import type { IRGraph } from '../types';
import { applyEdgeRoutingRules } from './edge-rules';

export function applyEdgeRules(graph: IRGraph): void {
  applyEdgeRoutingRules(graph);
}
